// Remessas sem nota · entradas/saídas sem documento fiscal
import { repo, db } from '../client.js';
import { escapeHTML, BRL, NUM, QTY, DT, SHORT } from '../shared.js';

export async function viewRemessas($c) {
  $c.innerHTML = `
    <header class="page-head">
      <div>
        <div class="kicker">SEM DOCUMENTO FISCAL</div>
        <h1>Remessas <strong>sem nota</strong></h1>
        <p class="lead">Entradas e saídas que rolam sem NF: RMA antecipado, demos, amostras, transferência interna, ajuste de inventário. Tudo registrado com responsável e foto.</p>
      </div>
      <div class="page-head-actions">
        <button class="btn btn-blue" id="btn-nova-rsn">+ Nova remessa</button>
      </div>
    </header>

    <div class="card">
      <div class="card-head"><h2>Remessas <span class="count" id="rsn-count">…</span></h2></div>
      <div id="rsn-list"></div>
    </div>

    <div class="card mt-md" id="rsn-form-card" style="display:none;">
      <div class="card-head">
        <h2>Nova remessa sem nota</h2>
        <button class="btn-mini" id="btn-close-rsn">×</button>
      </div>
      <form id="form-rsn" class="form-stack">
        <div class="grid-2">
          <label>Tipo
            <select id="rsn-tipo" required>
              <option value="entrada_sem_nota">Entrada sem nota</option>
              <option value="saida_sem_nota">Saída sem nota</option>
              <option value="transferencia_interna">Transferência interna</option>
              <option value="ajuste_inventario">Ajuste de inventário</option>
              <option value="demo">Demo</option>
              <option value="amostra">Amostra</option>
              <option value="outro">Outro</option>
            </select>
          </label>
          <label>Fluxo
            <select id="rsn-fluxo">
              <option value="">— sem direção (interno) —</option>
              <option value="inbound">inbound (entrada)</option>
              <option value="outbound">outbound (saída)</option>
            </select>
          </label>
          <label>Parceiro / origem<input id="rsn-parceiro" placeholder="ex: TELEFONICA RMA antecipado"></label>
          <label>CNPJ (opcional)<input id="rsn-cnpj" placeholder="ex: 02.558.157/0001-62"></label>
          <label>Responsável<input id="rsn-resp" placeholder="quem aprovou" required></label>
          <label>Conferente<input id="rsn-conf" placeholder="quem fez"></label>
          <label>Nº externo<input id="rsn-numero" placeholder="ex: RMA-998877"></label>
          <label>Valor estimado (R$)<input id="rsn-valor" type="number" step="0.01"></label>
        </div>
        <label>Motivo (obrigatório)<textarea id="rsn-motivo" rows="2" required placeholder="por que sem NF · ex: RMA antecipado, equipamento em demo"></textarea></label>
        <label>Observações<textarea id="rsn-obs" rows="2"></textarea></label>

        <h3 class="mt-md mb-sm">Itens</h3>
        <div id="rsn-itens"></div>
        <button type="button" class="btn-mini" id="rsn-add-item">+ adicionar item</button>

        <div class="row gap-sm mt-md">
          <button type="submit" class="btn btn-blue">Registrar remessa</button>
          <button type="button" class="btn-mini" id="rsn-cancel">cancelar</button>
        </div>
      </form>
    </div>

    <div class="grid-2 mt-md">
      <div class="card">
        <div class="card-head"><h2>Tipos comuns</h2></div>
        <table class="tbl">
          <tbody>
            <tr><td><span class="pill pill-blue">entrada sem nota</span></td><td>Item chega antes da NF · RMA antecipado · equipamento de teste</td></tr>
            <tr><td><span class="pill pill-amber">saída sem nota</span></td><td>Demo · empréstimo · troca emergencial</td></tr>
            <tr><td><span class="pill pill-mute">transferência interna</span></td><td>Move entre áreas do galpão sem NF</td></tr>
            <tr><td><span class="pill pill-mute">ajuste inventário</span></td><td>Correção pós-contagem cíclica</td></tr>
          </tbody>
        </table>
      </div>
      <div class="card">
        <div class="card-head"><h2>Regra-de-ouro</h2></div>
        <p class="body">Toda remessa sem nota é <strong style="font-weight:500;">temporária</strong>. O sistema permite registrar, mas o supervisor deve buscar a NF retroativa em até 7 dias. Acima disso, vira divergência aberta automática.</p>
        <p class="caption">Registrar com foto + responsável é evidência contratual; sem isso, vira narrativa contra narrativa.</p>
      </div>
    </div>
  `;

  let rsns = [];
  try { rsns = await repo.remessasSemNota(); } catch (e) { /* */ }
  const listEl = document.getElementById('rsn-list');
  document.getElementById('rsn-count').textContent = rsns.length;

  if (rsns.length === 0) {
    listEl.innerHTML = '<div class="empty">Nenhuma remessa sem nota registrada.</div>';
  } else {
    listEl.innerHTML = `
      <table class="tbl">
        <thead><tr><th>Número</th><th>Tipo</th><th>Fluxo</th><th>Data</th><th>Parceiro</th><th>Motivo</th><th class="num">Vols</th><th class="num">R$ est.</th><th>Status</th></tr></thead>
        <tbody>${rsns.map(r => `
          <tr>
            <td class="mono strong">${escapeHTML(r.numero)}</td>
            <td><span class="pill ${pillTipo(r.tipo)}">${escapeHTML((r.tipo || '').replace(/_/g, ' '))}</span></td>
            <td>${r.fluxo ? `<span class="pill ${r.fluxo === 'inbound' ? 'pill-green' : 'pill-amber'}">${r.fluxo}</span>` : '<span class="text-mute text-sm">interno</span>'}</td>
            <td class="mono text-sm">${DT(r.data_evento)}</td>
            <td>${escapeHTML(SHORT(r.parceiro_nome || '—', 28))}</td>
            <td>${escapeHTML(SHORT(r.motivo || '', 50))}</td>
            <td class="num">${r.qtd_volumes || 0}</td>
            <td class="num">${r.valor_estimado ? BRL(r.valor_estimado) : '—'}</td>
            <td><span class="pill ${pillStatusRSN(r.status)}">${escapeHTML(r.status)}</span></td>
          </tr>`).join('')}
        </tbody>
      </table>`;
  }

  // criar
  document.getElementById('btn-nova-rsn').addEventListener('click', () => {
    document.getElementById('rsn-form-card').style.display = 'block';
    document.getElementById('rsn-form-card').scrollIntoView({ behavior: 'smooth' });
  });
  document.getElementById('btn-close-rsn').addEventListener('click', () => document.getElementById('rsn-form-card').style.display = 'none');
  document.getElementById('rsn-cancel').addEventListener('click', () => document.getElementById('rsn-form-card').style.display = 'none');

  const itensWrap = document.getElementById('rsn-itens');
  const addItem = () => {
    const div = document.createElement('div');
    div.className = 'row gap-sm mb-sm';
    div.innerHTML = `
      <input class="rsn-sku" placeholder="SKU" style="flex:2;">
      <input class="rsn-desc" placeholder="descrição" style="flex:3;">
      <input class="rsn-qtd" type="number" placeholder="qtd" value="1" step="0.01" min="0" style="flex:1;">
      <input class="rsn-serial" placeholder="serial" style="flex:1;">
      <button type="button" class="btn-mini" data-rm>×</button>
    `;
    div.querySelector('[data-rm]').addEventListener('click', () => div.remove());
    itensWrap.appendChild(div);
  };
  addItem();
  document.getElementById('rsn-add-item').addEventListener('click', addItem);

  document.getElementById('form-rsn').addEventListener('submit', async (e) => {
    e.preventDefault();
    const tipo = document.getElementById('rsn-tipo').value;
    const fluxo = document.getElementById('rsn-fluxo').value || null;
    const parceiro_nome = document.getElementById('rsn-parceiro').value;
    const parceiro_cnpj = document.getElementById('rsn-cnpj').value;
    const responsavel = document.getElementById('rsn-resp').value;
    const conferente = document.getElementById('rsn-conf').value;
    const numero_externo = document.getElementById('rsn-numero').value;
    const motivo = document.getElementById('rsn-motivo').value;
    const observacoes = document.getElementById('rsn-obs').value;
    const valor_estimado = parseFloat(document.getElementById('rsn-valor').value || '0') || null;
    const itens = [];
    itensWrap.querySelectorAll('.row').forEach(r => {
      const sku = r.querySelector('.rsn-sku').value.trim();
      if (!sku) return;
      itens.push({
        sku_codigo: sku || null,
        descricao: r.querySelector('.rsn-desc').value || null,
        qtd: parseFloat(r.querySelector('.rsn-qtd').value || '1'),
        serial: r.querySelector('.rsn-serial').value || null,
      });
    });
    try {
      await repo.criarRemessaSemNota({
        tipo, fluxo, parceiro_nome, parceiro_cnpj, responsavel, conferente,
        motivo, numero_externo, valor_estimado, observacoes, itens,
      });
      viewRemessas($c);
    } catch (err) { alert('Erro: ' + err.message); }
  });
}

function pillTipo(t) {
  if (!t) return 'pill-mute';
  if (t.startsWith('entrada')) return 'pill-blue';
  if (t.startsWith('saida')) return 'pill-amber';
  return 'pill-mute';
}
function pillStatusRSN(s) {
  return { aberta: 'pill-amber', em_andamento: 'pill-blue', concluida: 'pill-green', cancelada: 'pill-mute' }[s] || 'pill-mute';
}
